import PropTypes from "prop-types";
import React, { Component } from "react";
import List from "@mui/material/List";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import FileChip from "components/Shared/FileChip";
import { dateTimeToString } from "components/Shared/Formatters";

class FileList extends Component {  
  constructor(props) {
    super(props);
    this.tooltip = this.tooltip.bind(this);
  }

  tooltip(index, item) {
    let dateString = dateTimeToString(item.uploadDate);
    if (!dateString) return "";

    return (
      <ReactTooltip
          id={"tooltip-" + index}
          place="bottom"
          className="file-tooltip"
          delayShow={500}
          offset={4}>
          <span>
            Uploaded: {dateString}  
          </span>
        </ReactTooltip>
    );
  }

  render() {  
      const { fileList, token } = this.props;

      if (fileList.length === 0) {
        return (
          <div style={{fontStyle: "italic"}}>
            No Files have been attached.
          </div>
        );
      }

      return (           
          <List style={{ display: "inline" }}>
            {
              fileList.map((fileItem, index) => (
                <div style={{ display: "inline-flex", margin: "10px" }}
                  key={"attached-" + index}>

                  <a data-tooltip-id={"tooltip-" + index}>
                    <FileChip
                      displayName={fileItem.fileName}
                      uri={fileItem.downloadUrl}
                      token={token}
                    />
                  </a>
                  {
                    this.tooltip(index, fileItem)
                  }
                </div>
              ))
            }
        </List>
      );
  }
}

FileList.propTypes = {
    fileList: PropTypes.array.isRequired,
    token: PropTypes.string.isRequired,
};

export default FileList;